module.exports = __webpack_public_path__ + "assets/life_close_v1.333a9362.svg";